import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: { autocompleteHotels: url },
} = config

const getHotelsLocations = (params) => axios.get(`${url}${params}`, { headers: getHeaders() })

export default { getHotelsLocations }
